module.exports = __webpack_public_path__ + "static/media/mockup.f46ae48d.svg";